export { default } from '@material-ui/icons/InsertDriveFile';
